import axios from "axios";
import log2 from "../utils/log2";
import * as _ from "lodash";
import store from "../store";
import { CONFIG } from "../utils/config";

// let SOCKET_URL = !CONFIG.isProd && CONFIG.isMobile ? "http://mobile-socket-local.supsis.live" : process.env.SOCKET_URL;
let SOCKET_URL = process.env.SOCKET_URL;
const log = log2("hostFetcher");
const request = axios.create({
    baseURL: SOCKET_URL,
    timeout: 20000, // request timeout
});

const lastSocketServers = {
    servers: [],
    fetchTime: Date.now(),
    failedServers: [],
};

// Rate limiter: 60 saniyede maksimum 12 request (5 saniyede 1 request)
const rateLimiter = {
    requestTimestamps: [],
    maxRequestsPerMinute: 12,
    windowMs: 60000, // 60 saniye
    minIntervalMs: 5000, // 5 saniye minimum interval
    allowFirstNRequests: 10,
    requestCount: 0,
    canMakeRequest() {
        this.requestCount++;
        if (this.requestCount <= this.allowFirstNRequests) {
            return { allowed: true, waitTime: 0 };
        }
        const now = Date.now();
        // 60 saniyeden eski timestamp'leri temizle
        this.requestTimestamps = this.requestTimestamps.filter((ts) => now - ts < this.windowMs);

        // Son request'ten bu yana geçen süreyi kontrol et
        const lastRequestTime = this.requestTimestamps[this.requestTimestamps.length - 1];
        if (lastRequestTime && now - lastRequestTime < this.minIntervalMs) {
            const waitTime = this.minIntervalMs - (now - lastRequestTime);
            log.debug("Rate limit: minimum interval not met, need to wait", waitTime, "ms");
            return { allowed: false, waitTime };
        }

        // 60 saniye içindeki request sayısını kontrol et
        if (this.requestTimestamps.length >= this.maxRequestsPerMinute) {
            const oldestTimestamp = this.requestTimestamps[0];
            const waitTime = this.windowMs - (now - oldestTimestamp);
            log.debug("Rate limit: max requests per minute reached, need to wait", waitTime, "ms");
            return { allowed: false, waitTime };
        }

        return { allowed: true, waitTime: 0 };
    },

    recordRequest() {
        this.requestTimestamps.push(Date.now());
    },
};

const isValidResponse = (servers) => {
    const selfHost = servers.find((x) => x.self);
    if (selfHost && selfHost.ready) return true;
    else return false;
};

export const performUpdateSocketServers = (force = false) => {
    const rateLimitCheck = rateLimiter.canMakeRequest();
    if (force) {
        rateLimitCheck.allowed = true;
        rateLimitCheck.waitTime = 0;
    }
    if (!rateLimitCheck.allowed) {
        log.warn("Rate limit reached, scheduling next request in", rateLimitCheck.waitTime, "ms");
        // Sekme inactive ise daha uzun bekle
        const isTabVisible = document.visibilityState === "visible";
        const adjustedWaitTime = isTabVisible ? rateLimitCheck.waitTime : Math.max(rateLimitCheck.waitTime, 10000);
        setTimeout(updateSocketServers, adjustedWaitTime);
        return;
    }
    const siteId = store.state.site?.site?._id;
    if (!siteId) {
        log.warn("Site ID not available, skipping socket server update");
        return;
    }

    log.info("updating socket servers");
    rateLimiter.recordRequest();

    request
        .get("/hosts?from=vpanel&siteId=" + store.state.site?.site?._id)
        .then((res) => {
            log.debug("updateSocketServers", res.data);
            const servers = res.data;
            if (isValidResponse(servers)) {
                lastSocketServers.servers = servers;
                lastSocketServers.fetchTime = Date.now();
                lastSocketServers.failedServers = [];
            } else {
                log.warn("Socket Servers is not valid, re-fetch will run in a seconds ");
                setTimeout(updateSocketServers, 5000); // minimum interval'e uygun hale getirildi
            }
        })
        .catch((err) => {
            console.error(err);
            log.error("Socket servers fetch error", { err: err.message });
            setTimeout(updateSocketServers, 5000); // minimum interval'e uygun hale getirildi
        });
};
const updateSocketServers = _.debounce(performUpdateSocketServers, 1000);

updateSocketServers();

let nextCallCount = 0;
export const getNextSocketServerCandidate = (print) => {
    if (nextCallCount === 0) updateSocketServers();
    nextCallCount++;
    const allServers = [...lastSocketServers.servers];
    const failedServers = [...lastSocketServers.failedServers];

    const validServers = _.orderBy(
        allServers.filter((x) => x.ready && !x.circuitBreaker),
        ["cpu.load", "uptime"],
        ["asc", "asc"]
    ).filter((x) => !failedServers.includes(x.instanceId));
    if (print) {
        log.info("getNextSocketServerCandidate", {
            allServers: allServers.map((x) => _.takeRight(x.instanceId, 3).join("")),
            failedServers: failedServers.map((x) => _.takeRight(x, 3).join("")),
            validServers: validServers.map((x) => _.takeRight(x.instanceId, 3).join("")),
        });
    }
    const candidateServer = _.head(validServers);
    if (!candidateServer && allServers.length === failedServers.length && validServers.length === 0)
        updateSocketServers();
    return candidateServer;
};

export const markFailedSocketServer = (id) => {
    lastSocketServers.failedServers.push(id);
    lastSocketServers.failedServers = _.uniq(lastSocketServers.failedServers);
    if (!getNextSocketServerCandidate(false)) {
        updateSocketServers();
    }
};

setInterval(updateSocketServers, 60 * 1000);
(() => {
    performUpdateSocketServers(true);
})();



// WEBPACK FOOTER //
// ./src/api/hostFetcher.js